const NAMESPACE = "libraryFolder";

const KEYS = {
    emptyText: "emptyText",
    urlLabel: "urlLabel",
    copyAccessUrlLabel: "copyAccessUrlLabel",
    renameText: "renameText",
    deleteText: "deleteText",
    historyText: "historyText",
    uploadNewVersionText: "uploadNewVersionText",
    sampleMessage: "sampleMessage",
    nameColumnHeader: "nameColumnHeader",
    publishedColumnHeader: "publishedColumnHeader"
};

const MESSAGES = {
    [KEYS.emptyText]: {
        value: "This folder is empty.",
        comment: "No items in folder text"
    },
    [KEYS.urlLabel]: {
        value: "Access URL:",
        comment: "URL label text"
    },
    [KEYS.copyAccessUrlLabel]: {
        value: "Copy Access URL",
        comment: "Copy access URL button text"
    },
    [KEYS.renameText]: {
        value: "Rename",
        comment: "Rename button text"
    },
    [KEYS.deleteText]: {
        value: "Delete",
        comment: "Delete button text"
    },
    [KEYS.historyText]: {
        value: "File History",
        comment: "File history button text"
    },
    [KEYS.uploadNewVersionText]: {
        value: "Upload New Version",
        comment: "Upload new file version button text"
    },
    [KEYS.sampleMessage]: {
        value: "This is a stubbed sample item for compatibility purposes only, and cannot be altered.",
        comment: "Sample file message"
    },
    [KEYS.nameColumnHeader]: {
        value: "Name",
        comment: "Text for name column header"
    },
    [KEYS.publishedColumnHeader]: {
        value: "Published",
        comment: "Text for published column header"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
